export var IPeriodUnit;
(function (IPeriodUnit) {
    IPeriodUnit[IPeriodUnit["NONE"] = 0] = "NONE";
    IPeriodUnit[IPeriodUnit["MILLISECOND"] = 1] = "MILLISECOND";
    IPeriodUnit[IPeriodUnit["SECOND"] = 2] = "SECOND";
    IPeriodUnit[IPeriodUnit["MINUTE"] = 3] = "MINUTE";
    IPeriodUnit[IPeriodUnit["HOUR"] = 4] = "HOUR";
    IPeriodUnit[IPeriodUnit["DAY"] = 5] = "DAY";
    IPeriodUnit[IPeriodUnit["WEEK"] = 6] = "WEEK";
    IPeriodUnit[IPeriodUnit["MONTH"] = 7] = "MONTH";
    IPeriodUnit[IPeriodUnit["YEAR"] = 8] = "YEAR";
})(IPeriodUnit || (IPeriodUnit = {}));
//# sourceMappingURL=ep.static.js.map